import React, { useEffect, useState } from 'react';
import { ShoppingCartIcon } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the first 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    window.open('https://glowliftessencemx.com/products/rodillera-de-calor-usb', '_blank');
  };
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 animate-in slide-in-from-bottom-full duration-300" data-id="element-200">
      <div className="flex items-center justify-between mb-2" data-id="element-201">
        <span className="text-sm font-bold text-slate-800" data-id="element-202">
          Rodillera Térmica
        </span>
        <span className="text-lg font-black text-blue-700" data-id="element-203">$699 MXN</span>
      </div>
      <button onClick={handleClick} className="w-full bg-green-600 text-white font-bold py-3 px-4 rounded-xl flex items-center justify-center gap-2 animate-pulse" data-id="element-204">
        <ShoppingCartIcon className="w-5 h-5" data-id="element-205" />
        <span data-id="element-206">Pedir Ahora - Pago en Casa</span>
      </button>
    </div>;
}